export default __webpack_public_path__ + "static/media/252.e6753112.png";